import React, { useEffect } from "react";
import { Button, Input } from "../../../../Components/StyledComponents";
import { onTranslation, onlyNum } from "../../../../Utils/functions";
import './CreateOption.scss';
import {cloneDeep} from 'lodash-es';
import { convertCost } from "../../../../Utils/functions";
import { support_language } from "../../../../Utils/services";
import { useSelector } from "react-redux";
import CheckLanguage from "../../../../Components/HotelOrder/CheckLanguage";

const ModifyOption = ({ info,patchOption }) => {
    const [ name, setName ] = React.useState({})
    const [ price, setPrice ] = React.useState(0)
    const [ desc, setDesc ] = React.useState({})
    const language = useSelector(state=> state.tableorder.language);

    useEffect(()=>{
        setName(cloneDeep(info.Name));
        setPrice(cloneDeep(info.Price));
        setDesc(cloneDeep(info.Description));
    }, []);

    const patch = () => {
        patchOption({
            OptionId : info._id.$oid,
            Name : name,
            Price: price,
            Description : desc
        })
    }
    const translationBtn = async () => {
        const trans_language = Object.entries(language).map(([key, value]) => value === true && key).filter(item => item !== false);
        const trans_data = [name.ko, desc.ko];
        const trans_value = ['name', 'desc'];
        const data = await onTranslation(trans_language, trans_data, trans_value);
        setName({...data.name});
        setDesc({...data.desc});
    };

    return (
        <div className="create-option">
            <div>
                <p className="label">옵션정보</p>
                <p className="label" style={{width:'100%', color:'#f95f53'}}>※ 테이블 오더에 보여지는 옵션 이름만 설정할 수 있습니다.</p>
                <p className="label" style={{width:'100%', color:'#f95f53'}}>※ 금액 변경을 원하실 경우 포스에서 옵션 정보를 변경해주세요.</p>
                <div className="row" style={{ marginTop : 16, marginBottom : 8 }}>
                    <Input value={name.ko} onChange={(e) => setName({...name, ko: e.target.value})} placeholder="예) 1인분, 300g 등" style={{ width : 150, marginRight: 16, paddingLeft:16, paddingRight:16 }}/>
                    <label htmlFor={`price`} data-domain="원">
                        <Input htmlFor={`price`} onChange={(e) => setPrice(onlyNum(e.target.value))} value={convertCost(price)} placeholder="0" style={{ color:'#0F0F0F', width : 100, paddingLeft:16, paddingRight:16 }}/>
                    </label>
                </div>
            </div>
            <CheckLanguage>
                <div className='btn-row' style={{margin:'16px 0', alignItems:'center'}}>
                    <p className='label' style={{flex:1, textAlign:'right', margin: 0, marginRight: 8, color:'#f95f53'}} >서비스 준비 중입니다.</p>
                    <Button variant="sub" small className='save-btn' fontSize={16} onClick={translationBtn} disabled={true || name.ko === '' || typeof name.ko === 'undefined'}>
                        자동번역
                    </Button>
                </div>
                <div style={{display:'flex', flexDirection:'column', gap: 4, marginTop:8}}>
                    {support_language.map((item, index) => 
                        language[item.value] && <div className="row">
                            <p className="label">{item.text}</p>
                            <Input value={name[item.value]} onChange={(e) => setName({...name, [item.value]: e.target.value})} placeholder="예) 1인분, 300g 등" style={{ width : 278, marginLeft: 16, marginRight: 16, paddingLeft:16, paddingRight:16 }}/>
                        </div>
                    )}
                </div>
            </CheckLanguage>
            <div className='btn-row'>
                <Button variant="main" className='save-btn' fontSize={16} disabled={name.ko?.trim() === ''} onClick={() => patch()}>
                    수정하기
                </Button>
            </div>
        </div>
    )
}

export default ModifyOption;